import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import {
  registerItemsKeys,
  RequestTypes,
} from '@core/react-query/features/registers/registers/register/items'
import { RequestErrorType } from '@core/utils/api-axios-instance'

interface DownloadRegisterItemsResponse {
  url: string
  directUrl: string
  key: string
}

export const useDownloadRegisterItems = (
  options?: UseMutationOptions<
    DownloadRegisterItemsResponse,
    RequestErrorType,
    RequestTypes['downloadRegisterItems']
  >,
) => {
  return useMutation({
    ...registerItemsKeys.downloadRegisterItems,
    ...options,
  })
}
